import { render, staticRenderFns } from "./FulfilmentOverridesList.vue?vue&type=template&id=31d63ea8"
import script from "./FulfilmentOverridesList.vue?vue&type=script&lang=js"
export * from "./FulfilmentOverridesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports